<template>  
    <section class="block block--gallery">
        <div class="container mb-1 mb-sm-2">
            <h2 v-if="block.title">{{ block.title }}</h2>
            <div v-if="block.subtitle" class="subtitle">{{ block.subtitle }}</div>
            <div v-if="block.content" v-html="block.content"></div>
        </div>
        <div :class="{ container : block.width === 'container' }">
            <div 
                v-if="block.images.length > 2"
                class="row"
                :class="{ 'mx-sm-1' : block.width === 'full' }">
                <div
                    v-for="(image, index) in block.images"
                    :key="index"
                    class="col-sm-6 col-md-4 position-relative mb-1 mb-sm-2">
                    <div
                    class="gallery__img"
                    :style="{ backgroundImage: `url('${$VUE_APP_API_URL + image.url}')` }"
                    :alt="image.caption"></div>
                </div>
            </div>
            <div class="row" v-else-if="block.images.length == 2">
                <div
                    v-for="(image, index) in block.images"
                    :key="index"
                    class="col-sm-6 position-relative">
                    <div
                    class="gallery__img"
                    :style="{ backgroundImage: `url('${$VUE_APP_API_URL + image.url}')` }"
                    :alt="image.caption"></div>
                </div>
            </div>
            <div class="row" v-else>
                <img
                    :src="$VUE_APP_API_URL + block.images[0].url"
                    :alt="block.images[0].caption"
                    class="img-fluid w-100">
            </div>
        </div>
    </section>
</template>

<script>

export default { 
    name: 'gallery',

    props: {
        block: {
            type: Object,
            default: () => {}
        }
    }
}
</script>